import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import ConversationMessage from './ConversationMessage';
import ConversationForm from './ConversationForm';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,    
    overflowY:'auto',
    maxHeight:700,
    marginBottom:70
  },
  inner: {
    padding: theme.spacing(2),
    minHeight: 400,

  }
}));
function ConversationMessages({getData, messages, WorkOrderId, imageList, TechnicianId, className, ...rest }) {
  const classes = useStyles();
  return (
    <div
      className={clsx(classes.root, className)}
    >
      <div className={classes.inner}>
        {messages.map((message) => (

          <ConversationMessage
            imageList={imageList[message.Sender]}
            key={message.MessageId}
            message={message}
            TechnicianId={TechnicianId}
          />
        ))}
      </div>
      <ConversationForm getData={getData} messages={messages} WorkOrderId={WorkOrderId} />

    </div>
  );
}

ConversationMessages.propTypes = {
  className: PropTypes.string,
  messages: PropTypes.array.isRequired
};

export default ConversationMessages;
